import React, { useEffect } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useForm, Controller } from "react-hook-form";

// Custom.
import { EducationDialogProps, Education } from "./global";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { getInitialState } from "./state";
import VoTextField from "@vocollege/components/dist/VoTextField";
import { VoDatePickerField } from "@vocollege/components/dist/VoPickerField";

const EducationDialog: React.FC<EducationDialogProps> = (props) => {
  const { item, onClose, onSave } = props;

  const { control, reset, setValue, formState, getValues } = useForm<Education>(
    {
      defaultValues: getInitialState(),
      mode: "onChange",
    },
  );
  const { isValid, isDirty } = formState;

  // Methods.

  const handleSave = () => {
    if (!onSave) {
      return;
    }
    let changedEducation = { ...item };
    changedEducation.pivot = getValues().pivot;
    onSave(changedEducation);
  };

  // Effects.

  useEffect(() => {
    reset(item);
  }, [item, reset]);

  return (
    <Dialog onClose={onClose} open={Boolean(item)}>
      <DialogTitle>{item.title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Controller
              name={`pivot.certified`}
              control={control}
              rules={{
                required: I18n.get.form.errors.required,
              }}
              render={({ field }) => (
                <VoDatePickerField
                  renderInput={(params: any) => (
                    <VoTextField
                      {...params}
                      required
                      fullWidth
                      variant="filled"
                      label={I18n.get.form.labels.certified}
                      size="small"
                    />
                  )}
                  label={I18n.get.form.labels.certified}
                  value={getValues(field.name)}
                  onChange={(value: any) =>
                    setValue(field.name, value.format("YYYY-MM-DD"), {
                      shouldDirty: true,
                      shouldValidate: true,
                    })
                  }
                  inputFormat={"YYYY-MM-DD"}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name={`pivot.comments`}
              control={control}
              render={({ field }) => (
                <VoTextField
                  {...field}
                  value={getValues(field.name) || ""}
                  fullWidth
                  multiline
                  minRows={2}
                  variant="filled"
                  label={I18n.get.form.labels.comments}
                  size="small"
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {I18n.get.actions.cancel}
        </Button>
        <Button
          onClick={handleSave}
          color="secondary"
          variant="contained"
          disabled={!isDirty || !isValid}
        >
          {I18n.get.actions.save}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EducationDialog;
